import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';
import { CompetitivePriceFileEntity } from './competitive-price-file.entity';
import { ItemEntity } from './item.entity';

@Index('fk_client__id', ['fkClientId'], {})
@Index('fk_item__id', ['fkItemId'], {})
@Entity('competitive_price')
export class CompetitivePriceEntity extends BaseEntity {
	@Column('decimal', { name: 'price', nullable: true, precision: 15, scale: 6 })
	public price!: string | null;

	@Column('varchar', { name: 'vendorName', length: 255 })
	public vendorName!: string;

	@Column('int', { name: 'fk_item__id', unsigned: true })
	public fkItemId!: number;

	@Column('int', { name: 'fk_client__id', unsigned: true })
	public fkClientId!: number;

	@ManyToOne(() => ItemEntity, (item) => item.competitivePrices, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_item__id', referencedColumnName: 'id' }])
	public fkItem!: ItemEntity;

	@ManyToOne(() => ClientEntity, (client) => client.competitivePrices, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;

	@OneToMany(
		() => CompetitivePriceFileEntity,
		(competitivePriceFile) => competitivePriceFile.fkCompetitivePrice,
		{},
	)
	public competitivePriceFiles!: Array<CompetitivePriceFileEntity>;
}
